import React from "react";
import {message, Radio} from "antd";
import {OptionProps} from "antd/lib/select";
import {RadioChangeEvent} from "antd/lib/radio";
import "../DynamicForm.scss";
import {RadioElementProps} from "@data-force/app";
import {connect} from "react-redux";
import {clearAlerts} from "../../../store/actions/layout";
import {ClearAlertsAction} from "../../../interfaces/store/actions/layout";

interface DispatchProps {
    clearAlerts(): ClearAlertsAction
}

export type Props = RadioElementProps & DispatchProps;

class RadioElement extends React.Component<Props> {
    constructor(props: Props) {
        super(props);

        this.radioChangeHandler = this.radioChangeHandler.bind(this);
    }

    radioChangeHandler({target: {value}}: RadioChangeEvent): void {
        const {
            fieldName, index, refElements, onSave,
        }: RadioElementProps = this.props;
        this.props.onChange({
            fieldName, value, index, refElements,
        });

        if (onSave) {
            onSave({
                fieldName,
                index,
                changeValue: value,
            });
        }
        message.destroy();
        this.props.clearAlerts();
    }

    render() {
        const {
            elementKey, value, allowedValues, className = "", index, readOnly,
        }: RadioElementProps = this.props;

        return (
            <Radio.Group
                className={className}
                key={`${elementKey}-${index}`}
                value={value}
                onChange={this.radioChangeHandler}
                disabled={readOnly}
            >
                {
                    allowedValues?.map((allowedValue: string, optionIndex: number)
                    : React.ReactElement<OptionProps> => (
                        <Radio key={`${optionIndex}-${allowedValue}-radio`} value={allowedValue}>
                            {allowedValue}
                        </Radio>
                    ))
                }
            </Radio.Group>
        );
    }
}

const mapDispatchToProps: DispatchProps = {
    clearAlerts,
};

export default connect(null, mapDispatchToProps)(RadioElement);
